import moment from 'moment'
export function transferTime (time) {
  var times = time
  var shiqu = new Date().getTimezoneOffset() / 60
  if (shiqu < 0) {
    shiqu = '+' + shiqu * (-1)
  } else {
    shiqu = shiqu * (-1)
  }
  var zone = 'GMT' + shiqu
  var timezone = zone || 'PST'
  var gmttimezone = ''
  if (times === '' || times === null || times === undefined) {
    return ''
  }
  var format = 'YYYY-MM-DD HH:mm:ss'
  switch (timezone) {
    // convert PST to GMT
    case 'PST':
      gmttimezone = 'GMT-8'
      break
    default:
      gmttimezone = timezone
  }
  var localOffset = new Date().getTimezoneOffset()
  var convertedMillis = times
  var offset = gmttimezone.substr(4, 1)
  if (gmttimezone.indexOf('GMT+') !== -1) {
    convertedMillis = new Date(times).getTime() + offset * 60 * 60000 + localOffset * 60000
  } else if (gmttimezone.indexOf('GMT-') !== -1) {
    convertedMillis = new Date(times).getTime() - offset * 60 * 60000 + localOffset * 60000
  } else {
    // return PST by default
    timezone = 'PST'
    convertedMillis = new Date(times).getTime() - 8 * 60 * 60000 + localOffset * 60000
  }
  return moment(convertedMillis).format(format) + ' ' + timezone
}



// WEBPACK FOOTER //
// ./App/components/renamePage/util.js